import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import SendIcon from '@mui/icons-material/Send';
import {makeStyles} from '@mui/styles';
//import {Theme} from './Theme';
//import useStyles from './Styles';

interface Props {
	close(): void,
	open:boolean,
	variant?: string,
}

const variantIcon = {
	success: CheckCircleIcon,
	send: SendIcon,
	warning: WarningIcon,
	error: ErrorIcon,
	info: InfoIcon,
};

const useStyles = makeStyles(() => ({
	success: {
	  backgroundColor: "#43a047!important",
	},
	send: {
	  backgroundColor: "#43a047!important",
	},
	error: {
	  backgroundColor: "#d32f2f!important",
	},
	info: {
	  backgroundColor: "#1976d2!important",
	},
	warning: {
	  backgroundColor: "#ffa000!important",
	},
	icon: {
	  fontSize: 20,
	},
	iconVariant: {
	  opacity: 0.9,
	  marginRight: "0.2em",
	},
	message: {
	  display: 'flex',
	  alignItems: 'center',
	},
}));

const Success = (props:Props)=> {
	const classes = useStyles();

	let Icon = variantIcon["success"];
	let mes = "";
	let classname;

	if( props.variant ){
		if( props.variant==="send" ){
			Icon = variantIcon["send"];
			mes = "送信しました"
			classname = classes["send"];
		}
		if( props.variant==="success" ){
			Icon = variantIcon["success"];
			mes = "成功しました"
			classname = classes["success"];
		}
	}

    return (
		<Snackbar
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'center',
			}}
			open={props.open}
			autoHideDuration={3000}
			onClose={props.close}
		>
			<SnackbarContent
				className={classname}
				message={
					<span id="toast-message" className={classes.message}>
						<Icon className={classname} />
						{mes}
					</span>
				}
				action={[
					<IconButton
						key="closeToast"
						aria-label="CloseToast"
						color="info"
						onClick={props.close}
					>
						<CloseIcon />
					</IconButton>,
				]}
			/>
		</Snackbar>
    )
}

export default Success;